var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("AttributeDeleterDialog", {
        attrs: { viewModel: _vm.attrDeleterDialog },
        on: {
          "delete-attribute": _vm.handleDeleteAttributeCommand,
          "show-dependencies": _vm.handleShowAttributeDependencies,
        },
      }),
      _vm._v(" "),
      _c("AttributeDependenciesDialog", {
        attrs: { viewModel: _vm.attrDependenciesDialog },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          !_vm.initialized
            ? _c("h3", [
                _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                _vm._v(" Loading... "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.initialized
            ? _c(
                "div",
                [
                  _c("h3", [_vm._v("Goal: " + _vm._s(_vm.goalName))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("GoalNavigation", {
                    attrs: {
                      ActivePage: "weighted-scores",
                      WorkspaceId: _vm.workspaceId,
                      ProjectId: _vm.projectId,
                      EvalModelId: _vm.evalModelId,
                      ScoringEnabled: false,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: _vm.url_CreateWeightedScorePage,
                          expression: "url_CreateWeightedScorePage",
                        },
                      ],
                      staticClass: "btn btn-success",
                    },
                    [_vm._v("\n                Create score\n            ")]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "table",
                    { staticClass: "table table-bordered table-hover" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.scores, function (s) {
                          return _c("tr", { key: s.Id }, [
                            _c("td", [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: _vm.url_EditWeightedScorePage(
                                        s.Id
                                      ),
                                      expression:
                                        "url_EditWeightedScorePage(s.Id)",
                                    },
                                  ],
                                  staticClass: "text-dark",
                                },
                                [_c("strong", [_vm._v(" " + _vm._s(s.Name))])]
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(s.Description) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(s.WeightsSetName) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(s.CriterionName) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "btn-group" }, [
                                _vm._m(1, true),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "sanitizedHref",
                                            rawName: "v-sanitizedHref",
                                            value:
                                              _vm.url_EditWeightedScorePage(
                                                s.Id
                                              ),
                                            expression:
                                              "url_EditWeightedScorePage(s.Id)",
                                          },
                                        ],
                                        staticClass: "dropdown-item",
                                      },
                                      [_vm._v("Edit")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShowAttributeDependencies(
                                              s.AttributeId
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("View dependencies")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShowAttributeDeleter(
                                              s.AttributeId
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Delete")]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [
          _vm._v(
            "\n                            Score\n                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            "\n                            Weights\n                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            "\n                            Criterion\n                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "90px" } }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "btn btn-outline-secondary dropdown-toggle",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [
        _vm._v("\n                                    Actions "),
        _c("span", { staticClass: "caret" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }